module.exports = __webpack_public_path__ + "static/media/motyer.3f533638.jpg";